export default __webpack_public_path__ + "static/media/twitter.d546aaa3.png";